import { render, staticRenderFns } from "./r-piggy-stage-config-table.vue?vue&type=template&id=a252989c"
import script from "./r-piggy-stage-config-table.vue?vue&type=script&lang=js"
export * from "./r-piggy-stage-config-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a252989c')) {
      api.createRecord('a252989c', component.options)
    } else {
      api.reload('a252989c', component.options)
    }
    module.hot.accept("./r-piggy-stage-config-table.vue?vue&type=template&id=a252989c", function () {
      api.rerender('a252989c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-piggy/r-piggy-stage-config-table.vue"
export default component.exports